<router-outlet (activate)="isLoading = false" />
@if (isLoading) {
    <div class="loading">
        <mat-spinner />
    </div>
}
